import { TableCell } from "@mui/material"
import { getFullNameOrEmail } from "../../../../../redux/user"
import { TeamMember } from "../../../../../types"
import { ProgramForm, ProgramFormFilter, TrainingProgramForm } from "../../types"
import HighlightedSearchText from "./HighlightedSearchText"

const TeamMemberCell = (props: {
  form: ProgramForm,
  isCollapsedCell: boolean,
  trainingProgramForm: TrainingProgramForm | null,
  tableCellStyles: any,
  colIndex: number,
  colWidths: number[],
  teamMembersById: Map<number, TeamMember>,
  formTeamMembers: TeamMember[],
  filter: ProgramFormFilter | null,
  searchValue: string,
}) => {
  const {
    form,
    isCollapsedCell,
    tableCellStyles,
    colIndex,
    colWidths,
    trainingProgramForm, 
    teamMembersById,
    formTeamMembers,
    filter,
    searchValue,
  } = props

  const userId = trainingProgramForm?.user_id ?? 0
  const user = teamMembersById.get(userId)  

  const values = {
    cell: userId ? getFullNameOrEmail(user) : '',
    filter: filter && filter.value !== 'None' ? filter.value : '',
  }
  
  return (
    <>
      {
        isCollapsedCell || (form.is_practice_only && !form.is_multiple_uploads) ?
          <TableCell
            sx={{
              ...tableCellStyles,
              width: colWidths[colIndex]
            }}
            align="center"
          >
            <HighlightedSearchText
              text={values.cell}
              searchValue={searchValue}
              filterValue={values.filter}
					  />
          </TableCell>
        :
          <TableCell
            sx={{
              ...tableCellStyles,
            }}
            align="center"
          >
            {formTeamMembers.length > 0 ? `${formTeamMembers.length} Team Members` : ''}
          </TableCell>
        }
    </>
  )
}

export default TeamMemberCell